import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import PasesLibres from '@/views/PasesLibres..vue'
import PlanesView from '@/views/PlanesView.vue'
import ServiciosView from '@/views/ServiciosView.vue'
import RutinasView from '@/views/RutinasView.vue'
import LoginView from '@/views/LoginView.vue'
import ContactanosView from '@/views/ContactanosView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },

    {
    path: '/PasesLibres',
    name: 'PasesLibres',
    component: PasesLibres
  },
     {
    path: '/PlanesView',
    name: 'PlanesView',
    component: PlanesView
  },
      {
    path: '/ServiciosView',
    name: 'ServiciosView',
    component: ServiciosView
  },
      {
    path: '/RutinasView',
    name: 'RutinasView',
    component: RutinasView
  },
        {
    path: '/LoginView',
    name: 'LoginView',
    component: LoginView
  },
         {
    path: '/ContactanosView',
    name: 'ContactanosView',
    component: ContactanosView
  },

 
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
